(function ($) {

	//TODO: Remove all 404 errors manually and the delete this file!

	let excludeURLs = [
		'https://www.b2brouter.net/es/ca',
		'https://www.b2brouter.net/es/ca/face',
		'https://www.b2brouter.net/es/ca/tot-sobre-la-facturacio-electronica-a-alemanya',
		'https://www.b2brouter.net/es/ca/format-edi',
		'https://www.b2brouter.net/es/ca/emetre-factura-electronica',
		'https://www.b2brouter.net/es/ca/que-es-peppol',
		'https://www.b2brouter.net/es/ca/plantilla-factura-excel',
		'https://www.b2brouter.net/es/ca/quan-es-obligatori-fer-una-factura-electronica',
		'https://www.b2brouter.net/es/ca/digitalitzar-se-o-morir-beneficis-de-la-facturacio-electronica-per-a-pimes',
		'https://www.b2brouter.net/es/ca/nova-funcionalitat-rep-factures-electroniques-amb-b2brouter',
		'https://www.b2brouter.net/es/terminos-y-condiciones',
		'https://www.b2brouter.net/global/partners-dev',
		'https://www.b2brouter.net/it/ottieni-il-massimo-dalla-fatturazione-elettronica',
		'https://www.b2brouter.net/es/ca/eticketsync',
		'https://www.b2brouter.net/it/nuova-funzionalita-ricevete-le-fatture-transfrontaliere-con-b2brouter',
		'https://www.b2brouter.net/it/ottieni-il-massimo-dalla-fatturazione-elettronica',
		'https://www.b2brouter.net/it/inviare-una-fattura-elettronica-in-europa',
		'https://www.b2brouter.net/it/b2brouter-fatturazione-elettronica-gratuita-con-la-rete-peppol',
		'https://www.b2brouter.net/de/b2bsync',
		'https://www.b2brouter.net/de/e-rechnung-api',
		'https://www.b2brouter.net/de/kontakt',
		'https://www.b2brouter.net/de/preise',
		'https://www.b2brouter.net/de/integration/apps',
		'https://www.b2brouter.net/de/e-rechnung-integration',
		'https://www.b2brouter.net/de/partners',
		'https://www.b2brouter.net/fr/facturation-electronique-gratuite',
		'https://www.b2brouter.net/fr/meilleure-plateforme-de-facture-electronique',
		'https://www.b2brouter.net/nl/b2brouter-gratis-elektronisch-factureren-via-het-peppol-netwerk',
		'https://www.b2brouter.net/it/ottieni-il-massimo-dalla-fatturazione-elettronica',
		'https://www.b2brouter.net/fr/b2bsync',
		'https://www.b2brouter.net/fr/partenaires',
		'https://www.b2brouter.net/fr/facturation-electronique-gratuite',
		'https://www.b2brouter.net/es/como-firmar-factura-electronica',
		'https://www.b2brouter.net/global/send-e-invoices-france',
		'https://www.b2brouter.net/nl/b2brouter-gratis-elektronisch-factureren-via-het-peppol-netwerk',
		'https://www.b2brouter.net/it/ottieni-il-massimo-dalla-fatturazione-elettronica',
		'https://www.b2brouter.net/be/free-einvoice',
		'https://www.b2brouter.net/and/que-es-una-factura-electronica-e-factura',
		'https://www.b2brouter.net/global/electronic-invoice-luxembourg',
		'https://www.b2brouter.net/global/how-to-choose-the-best-electronic-invoice-program',
		'https://www.b2brouter.net/es/ca/envia-factura-electronica-a-chorus-pro-amb-b2brouter-acces-point-certificat',
		'https://www.b2brouter.net/es/ca/b2b-router-ja-esta-connectat-amb-chorus-pro',
		'https://www.b2brouter.net/es/ca/envia-factura-electronica-a-europa-2',
		'https://www.b2brouter.net/de/elektronisches-fakturieren-effektiv-nutzen',
		'https://www.b2brouter.net/de/elektronisches-fakturieren-effektiv-nutzen-2',
		'https://www.b2brouter.net/es/como-solicitar-certificado-digital',
		'https://www.b2brouter.net/es/ca/com-sol·licitar-un-certificat-digital',
		'https://www.b2brouter.net/de/elektronisches-fakturieren-effektiv-nutzen',
		'https://www.b2brouter.net/de/elektronisches-fakturieren-effektiv-nutzen-2',
		'https://www.b2brouter.net/es/como-solicitar-certificado-digital',
		'https://www.b2brouter.net/es/ca/com-sol·licitar-un-certificat-digital',
		'https://www.b2brouter.net/es/ca/envia-factura-electronica-a-chorus-pro-amb-b2brouter-acces-point-certificat',
		'https://www.b2brouter.net/fr/envoyer-une-facture-electronique-vers-leurope',
		'https://www.b2brouter.net/fr/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/es/programa-factura-electronica',
		'https://www.b2brouter.net/de/integration-eines-erp-systems-mit-b2brouter',
		'https://www.b2brouter.net/de/pflicht-zur-xrechnung-das-sollten-sie-wissen',
		'https://www.b2brouter.net/de/wie-sieht-eine-xrechnung-aus',
		'https://www.b2brouter.net/de/peppol-access-point-das-sollten-sie-wissen',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/e-rechnung-elektronische-rechnungen-mit-b2brouter',
		'https://www.b2brouter.net/de/wie-erstellt-man-eine-erechnung',
		'https://www.b2brouter.net/de/9-fragen-zur-leitweg-id',
		'https://www.b2brouter.net/de/warum-xrechnung',
		'https://www.b2brouter.net/de/was-ist-eine-e-rechnung',
		'https://www.b2brouter.net/de/kleingewerbe-anmelden-die-10-wichtigsten-fragen-zur-kleingewerbeanmeldung',
		'https://www.b2brouter.net/de/wer-nutzt-peppol',
		'https://www.b2brouter.net/de/digitalisierung-der-oeffentlichen-beschaffung-in-deutschland',
		'https://www.b2brouter.net/de/wie-sieht-eine-erechnung-aus',
		'https://www.b2brouter.net/de/das-peppol-netzwerk',
		'https://www.b2brouter.net/de/e-rechnung-im-jahr-2021-welche-fragen-sie-sich-bei-der-umstellung-auf-die-xrechnung-stellen-sollten',
		'https://www.b2brouter.net/es/ca/crear-factura-electronica',
		'https://www.b2brouter.net/es/ca/que-es-una-factura-electronica-e-factura-2',
		'https://www.b2brouter.net/it/b2brouter-fatturazione-elettronica-gratuita-con-la-rete-peppol',
		'https://www.b2brouter.net/es/envia-factura-electronica-a-chorus-pro-con-b2brouter-acces-point-certificado',
		'https://www.b2brouter.net/es/sacale-todo-el-partido-a-la-factura-electronica',
		'https://www.b2brouter.net/es/automatiza-tu-facturacion-electronica-integrando-sage-con-b2brouter',
		'https://www.b2brouter.net/es/b2brouter-y-camara-de-madrid-jornada-sobre-la-automatizacion-de-la-facturacion-electronica',
		'https://www.b2brouter.net/de/fuer-wen-ist-die-e-rechnung-pflicht',
		'https://www.b2brouter.net/de/pflicht-zur-xrechnung-das-sollten-sie-wissen',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/e-rechnung-elektronische-rechnungen-mit-b2brouter',
		'https://www.b2brouter.net/de/wie-erstellt-man-eine-erechnung',
		'https://www.b2brouter.net/de/warum-xrechnung',
		'https://www.b2brouter.net/de/was-ist-eine-e-rechnung',
		'https://www.b2brouter.net/de/leitfaden-so-einfach-stellen-sie-ihr-it-system-auf-die-e-rechnung-um',
		'https://www.b2brouter.net/de/wie-erstellt-man-eine-zugferd-rechnung',
		'https://www.b2brouter.net/de/neuerungen-im-peppol-netzwerk-im-jahr-2020',
		'https://www.b2brouter.net/de/automatisieren-der-e-rechnung-mit-ms-dynamics-365-und-b2brouter',
		'https://www.b2brouter.net/de/fuer-wen-ist-die-e-rechnung-pflicht',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/e-rechnung-elektronische-rechnungen-mit-b2brouter',
		'https://www.b2brouter.net/de/warum-xrechnung',
		'https://www.b2brouter.net/de/was-ist-eine-e-rechnung',
		'https://www.b2brouter.net/es/autonomo-gastos-deducibles-por-trabajar-en-casa-2',
		'https://www.b2brouter.net/global/make-the-most-of-electronic-invoicing-2',
		'https://www.b2brouter.net/es/autonomo-ya-puedes-pagar-el-iva-en-el-momento-en-que-cobres-la-factura',
		'https://www.b2brouter.net/de/elektronisches-fakturieren-effektiv-nutzen',
		'https://www.b2brouter.net/de/neue-funktion-erhalt-elektronischer-rechnungen-mit-b2brouter',
		'https://www.b2brouter.net/de/leitfaden-so-einfach-stellen-sie-ihr-it-system-auf-die-e-rechnung-um',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/e-rechnung-loesungen-fuer-die-oeffentliche-verwaltung-und-lieferanten',
		'https://www.b2brouter.net/de/neuerungen-im-peppol-netzwerk-im-jahr-2020',
		'https://www.b2brouter.net/de/die-3-wichtigsten-fragen-zur-auftragsbestaetigung',
		'https://www.b2brouter.net/be/nl/maak-optimaal-gebruik-van-elektronische-facturering',
		'https://www.b2brouter.net/be/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/fr/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/be/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/fr/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/es/ca/que-es-un-codi-dire',
		'https://www.b2brouter.net/es/que-es-un-codigo-dire',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/wie-erstellt-man-eine-erechnung',
		'https://www.b2brouter.net/de/b2brouter-kostenlose-elektronische-fakturierung-ueber-das-peppol-netzwerk',
		'https://www.b2brouter.net/de/eine-e-rechnung-nach-europa-versenden',
		'https://www.b2brouter.net/es/ca/factura-eletronica-per-a-lloguers',
		'https://www.b2brouter.net/es/ca/peppol-lestandard-europeu-per-a-la-facturacio-electronica',
		'https://www.b2brouter.net/es/ca/com-enviar-una-factura-electronica-a-lajuntament-de-barcelona',
		'https://www.b2brouter.net/se/b2brouter-gratis-e-fakturering-via-peppols-natverk',
		'https://www.b2brouter.net/global/automatize-the-einvoicing-using-ms-dynamics-365-and-b2brouter-2',
		'https://www.b2brouter.net/global/how-do-you-send-einvoices-socomo',
		'https://www.b2brouter.net/se/fa-ut-mesta-mojliga-med-e-fakturering',
		'https://www.b2brouter.net/se/fordelarna-med-elektronisk-fakturering-kontra-pdf',
		'https://www.b2brouter.net/es/software-factura-electronica-transporte',
		'https://www.b2brouter.net/be/nl/maak-optimaal-gebruik-van-elektronische-facturering',
		'https://www.b2brouter.net/be/nl/nieuwe-functionaliteit-elektronische-facturen-ontvangen-met-b2brouter',
		'https://www.b2brouter.net/be/nl/elektronische-facturatie-tussen-b2brouter-gebruikers',
		'https://www.b2brouter.net/es/que-necesitas-saber-sii-aeat',
		'https://www.b2brouter.net/be/nl/hoe-maak-je-een-elektronische-factuur-voor-de-vlaamse-overheid',
		'https://www.b2brouter.net/be/nl/b2brouter-gratis-elektronische-facturering-via-het-peppol-netwerk',
		'https://www.b2brouter.net/es/sacale-todo-el-partido-a-la-factura-electronica',
		'https://www.b2brouter.net/be/nl/hoe-maak-je-een-elektronische-factuur-voor-de-vlaamse-overheid',
		'https://www.b2brouter.net/be/nl/b2brouter-gratis-elektronische-facturering-via-het-peppol-netwerk',
		'https://www.b2brouter.net/es/ca/programa-de-factures',
		'https://www.b2brouter.net/fr/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/be/savez-vous-ce-quest-une-facture-recurrente',
		'https://www.b2brouter.net/be/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/global/electronic-invoicing-between-b2brouter-users-2',
		'https://www.b2brouter.net/global/make-the-most-of-electronic-invoicing-2',
		'https://www.b2brouter.net/be/facturation-plus-rapide-grace-au-catalogue-produits',
		'https://www.b2brouter.net/fr/facturation-plus-rapide-grace-au-catalogue-produits',
		'https://www.b2brouter.net/es/ca/treu-li-tot-el-partit-a-la-factura-electronica',
		'https://www.b2brouter.net/be/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/es/ca/treu-li-tot-el-partit-a-la-factura-electronica',
		'https://www.b2brouter.net/es/ca/enviar-factures-electroniques-carrefour',
		'https://www.b2brouter.net/es/ca/automatitza-la-facturacio-electronica-amb-a3erp-i-b2brouter',
		'https://www.b2brouter.net/es/ca/com-enviar-factura-electronica-a-sonepar-iberica',
		'https://www.b2brouter.net/es/ca/automatitza-la-facturacio-electronica-amb-ms-dynamics-365-i-b2brouter',
		'https://www.b2brouter.net/es/ca/primers-passos-per-usar-b2brouter',
		'https://www.b2brouter.net/es/ca/faceb2b-facturacio-electronica-entre-empreses',
		'https://www.b2brouter.net/fr/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/be/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/global/make-the-most-of-electronic-invoicing-2',
		'https://www.b2brouter.net/global/b2brouter-free-electronic-invoicing-through-the-peppol-network-2',
		'https://www.b2brouter.net/se/snabbare-fakturering-tack-vare-produktkatalogen',
		'https://www.b2brouter.net/global/how-do-you-send-einvoices-socomo',
		'https://www.b2brouter.net/es/beneficios-de-la-facturacion-electronica-vs-el-pdf',
		'https://www.b2brouter.net/fr/savez-vous-ce-quest-une-facture-recurrente',
		'https://www.b2brouter.net/global/faster-invoicing-thanks-to-the-product-catalogue-2',
		'https://www.b2brouter.net/be/automatiser-la-facturation-electronique-a-laide-de-ms-dynamics-365-et-b2brouter',
		'https://www.b2brouter.net/fr/automatiser-la-facturation-electronique-a-laide-de-ms-dynamics-365-et-b2brouter',
		'https://www.b2brouter.net/de/b2brouter-kostenlose-elektronische-fakturierung-ueber-das-peppol-netzwerk',
		'https://www.b2brouter.net/de/das-peppol-netzwerk',
		'https://www.b2brouter.net/global/b2brouter-free-electronic-invoicing-through-the-peppol-network-2',
		'https://www.b2brouter.net/global/send-an-einvoice-to-europe-2',
		'https://www.b2brouter.net/be/b2brouter-facture-electronique-gratuite-via-le-reseau-peppol',
		'https://www.b2brouter.net/es/automatiza-la-facturacion-electronica-con-ms-dynamics-365-y-b2brouter',
		'https://www.b2brouter.net/es/automatiza-la-facturacion-electronica-con-a3rp-y-b2brouter',
		'https://www.b2brouter.net/global/benefits-of-electronic-invoicing-versus-pdf',
		'https://www.b2brouter.net/fr/savez-vous-ce-quest-une-facture-recurrente',
		'https://www.b2brouter.net/se/b2brouter-gratis-e-fakturering-via-peppols-natverk',
		'https://www.b2brouter.net/se/skicka-efaktura-till-europa',
		'https://www.b2brouter.net/de/e-rechnung-elektronische-rechnungen-mit-b2brouter',
		'https://www.b2brouter.net/de/was-ist-eine-e-rechnung',
		'https://www.b2brouter.net/se/b2brouter-gratis-e-fakturering-via-peppols-natverk',
		'https://www.b2brouter.net/es/b2b-router-ya-esta-conectado-con-chorus-pro',
		'https://www.b2brouter.net/fr/profiter-au-maximum-de-la-facturation-electronique',
		'https://www.b2brouter.net/de/was-ist-eine-xrechnung',
		'https://www.b2brouter.net/de/b2brouter-kostenlose-elektronische-fakturierung-ueber-das-peppol-netzwerk',
		'https://www.b2brouter.net/global/how-do-you-send-einvoices-socomo',
		'https://www.b2brouter.net/se/fa-ut-mesta-mojliga-med-e-fakturering',
		'https://www.b2brouter.net/es/ca/treu-li-tot-el-partit-a-la-factura-electronica',
		'https://www.b2brouter.net/es/beneficios-de-la-facturacion-electronica-vs-el-pdf',
		'https://www.b2brouter.net/es/sacale-todo-el-partido-a-la-factura-electronica',
		'https://www.b2brouter.net/be/nl/hoe-maak-je-een-elektronische-factuur-voor-de-vlaamse-overheid',
		'https://www.b2brouter.net/be/nl/b2brouter-gratis-elektronische-facturering-via-het-peppol-netwerk',
		'https://www.b2brouter.net/de/xrechnung-software',
		'https://www.b2brouter.net/de/die-gobd-definition-verfahrensdokumentation-und-neuerungen',
		'https://www.b2brouter.net/se/gratis-e-faktura-till-svenska-offentliga-sektorn-med-leverantorsportalen-b2brouter',
		'https://www.b2brouter.net/se/automatisera-e-faktureringen-med-ms-dynamics-365-och-b2brouter',
		'https://www.b2brouter.net/global/automatize-the-einvoicing-using-ms-dynamics-365-and-b2brouter-2',
		'https://www.b2brouter.net/global/make-the-most-of-electronic-invoicing-2',
		'https://www.b2brouter.net/global/benefits-of-electronic-invoicing-versus-pdf',
		'https://www.b2brouter.net/es/ca/enviar-factures-electroniques-carrefour',
		'https://www.b2brouter.net/se/fa-ut-mesta-mojliga-med-e-fakturering',
		'https://www.b2brouter.net/global/make-the-most-of-electronic-invoicing-2',
		'https://www.b2brouter.net/es/ca/faceb2b-facturacio-electronica-entre-empreses',
		'https://www.b2brouter.net/es/ca/treu-li-tot-el-partit-a-la-factura-electronica',
		'https://www.b2brouter.net/global/b2brouter-free-electronic-invoicing-through-the-peppol-network-2',
		'https://www.b2brouter.net/be/nl/automatiseer-de-e-facturering-met-ms-dynamics-365-en-b2brouter',
		'https://www.b2brouter.net/es/ca/automatitza-la-facturacio-electronica-amb-a3erp-i-b2brouter',
		'https://www.b2brouter.net/es/ca/automatitza-la-facturacio-electronica-amb-ms-dynamics-365-i-b2brouter',
		'https://www.b2brouter.net/es/cuanto-tiempo-hay-que-guardar-las-facturas-de-tu-empresa',
		'https://www.b2brouter.net/es/b2brouter-factura-electronica-gratuita-a-traves-de-la-red-peppol',
		'https://www.b2brouter.net/es/ca/b2brouter-factura-electronica-gratuita-a-traves-de-la-xarxa-peppol',
		'https://www.b2brouter.net/de/digitalisierung-der-oeffentlichen-beschaffung-in-deutschland',
		'https://www.b2brouter.net/es/ca/factura-electronica-entre-usuaris-de-b2brouter',
		'https://www.b2brouter.net/es/ca/que-es-millor-facturae-o-un-altre-proveidor-de-facturacio-electronica',
		'https://www.b2brouter.net/es/ca/primers-passos-per-usar-b2brouter',
		'https://www.b2brouter.net/fr/comment-mettre-en-place-facture-dematerialisee',
		'https://www.b2brouter.net/es/faceb2b-facturacion-electronica-entre-empresas',
		'https://www.b2brouter.net/es/b2brouter-factura-electronica-gratuita-a-traves-de-la-red-peppol',
		'https://www.b2brouter.net/es/por-que-elegir-b2b-router-ventajas',
		'https://www.b2brouter.net/es/automatiza-tu-facturacion-electronica-integrando-sage-con-b2brouter',
		'https://www.b2brouter.net/es/ca/b2brouter-factura-electronica-gratuita-a-traves-de-la-xarxa-peppol',
	];

	$.each( excludeURLs, function( key, url ) {
		$('a[href="' + url + '"]').attr('href', '#')
	});
})(jQuery);
("use strict");